import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { DeepPartial, useForm } from "react-hook-form";

import { CREATE_CMS } from "../cms.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateCmsInput } from "../../../__generated__/globalTypes";
import {
  CreateCmsMutation,
  CreateCmsMutationVariables,
} from "../../../__generated__/CreateCmsMutation";

interface IProps {
  defaultValues: DeepPartial<CreateCmsInput>;
  onCompleted: (id?: number | null) => any;
}

export const useCreateCms = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateCmsInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateCmsMutation,
    CreateCmsMutationVariables
  >(CREATE_CMS, {
    refetchQueries: ["CmsListQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createCms?.ok) {
        onCompleted(data.createCms.id);
      } else {
        throw Error(data?.createCms?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
